var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoise = function SvgNoise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M1 5c1.25 0 1.25 2.5 2.5 2.5S4.75 3 6 3s1.25 6.5 2.5 6.5S9.75 6 11 6s1.25 1.5 2.5 1.5S14.75 1 16 1s1.25 6.5 2.5 6.5S19.75 5 21 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M1 5c2.5 0 2.5 1.5 5 1.5s2.5-3 5-3 2.5 3 5 3S18.5 5 21 5",
    opacity: 0.2
  })));
};
export default SvgNoise;